import { setLocale } from 'yup'
import i18n from './index'

// Resolve messages when validation runs, so schemas follow language changes too.
setLocale({
  mixed: {
    default: () => i18n.global.t('validation.invalid'),
    required: () => i18n.global.t('common.required'),
    defined: () => i18n.global.t('common.required'),
    notNull: () => i18n.global.t('common.required'),
    notType: () => i18n.global.t('validation.invalid'),
    oneOf: () => i18n.global.t('validation.choice'),
  },
  string: {
    email: () => i18n.global.t('validation.email'),
    min: ({ min }) => i18n.global.t('validation.min_length', { min }),
    max: ({ max }) => i18n.global.t('validation.max_length', { max }),
  },
  number: {
    min: ({ min }) => i18n.global.t('validation.min_number', { min }),
    max: ({ max }) => i18n.global.t('validation.max_number', { max }),
    integer: () => i18n.global.t('validation.integer'),
  },
})
